import React, { useEffect, } from "react";
import { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Link, useNavigate, useParams } from "react-router-dom";
import AppLayout from "../components/AppLayout";
import {
  getBusinessDetails,
  editBusiness,
  patchBusinessLogo,
} from "../logic/business/action";
import { MdArrowBackIos, MdArrowForwardIos, MdCalendarMonth, MdCall, MdClose, MdCurrencyRupee, MdDelete, MdEdit, MdEmail, MdLogout, MdPeople, MdPerson, MdSave, MdShare } from "react-icons/md";
import Header from "../components/header";
import ProfileTab from "../components/profileTab";
import Card from "../components/card";
import { getBilling, getPlan } from "../logic/plans/action";
import GoogleCalendarSettings from "../components/GoogleCalendarSettings";
import moment from "moment";
import { Avatar, Button, Dialog, DialogActions, DialogContent, DialogTitle, Divider, FormControlLabel, FormGroup, Grid, IconButton, List, ListItem, ListItemIcon, ListItemText, Menu, MenuItem, Switch } from "@mui/material";
import { changePassword, deleteAccount, logOut } from "../logic/login/action";
import AppointmentAccordian from "../components/accordian";
import InputComponents from "../components/input";
import { setSelectedDate } from "../logic/dates/reducer";
import { compareDate, dayOfWeek, returnMonth, returnWeek } from "../utils/date";
import { addDate, removeDate, setInitialDate, setInitialMobileDate } from "../logic/dates/action";
import { setTimingsValue, setselectedTime } from "../logic/profile/reducer";
import { TimeField } from "@mui/x-date-pickers";
import { getCategories } from "../logic/categories/action";
import FormikForm from "../components/commonForm";
import { feildsPassword, initialValuesPassword, validationSchemaPassword } from "../fromsUtil/resetPassword";
import { feildsSocailMedia, initialValuesSocailMedia } from "../fromsUtil/socialMedia";
import { setProfileValue } from "../logic/business/reducer";
import { autoBookOpen, gettimings, savetimings, updateLabelProfile, updateProfile, updateProfileOpen } from "../logic/profile/actions";
import dayjs from "dayjs";
import { AccountPopup, AppointmentPopup, CalenderPopup, SharePopup } from "./home";
import { FaEye, FaEyeSlash } from "react-icons/fa";

const Profile = () => {
  const dispatch = useDispatch();
  const [editModeIndi, setEditModeIndi] = useState(false);
  const [editModeIndiValue, setEditModeIndiValue] = useState('');
  const [editModeIndiLabel, setEditModeIndiLabel] = useState('');
  const selectorAuth = useSelector(state=>state.auth);
  const [logoPreview, setLogoPreview] = useState(null);
  const [businessId, setBusinessId] = useState(null);


  const params = useParams();
  const profileState = useSelector(state=>state.profile);
  const nav = useNavigate();
  const selector = useSelector((state) => state.business);
  const [confirmTimings, setconfirmTimings] = useState(false);
  useEffect(() => {
    setInitialDate(dispatch);
    setInitialMobileDate(dispatch);
    getBilling(dispatch);
    getBusinessDetails(dispatch, params.id);
    getCategories(dispatch);
    getPlan(dispatch);
  
  }, []);

  useEffect(() => {
    gettimings(dispatch,profileState.selectedTime)
  
  }, [profileState.selectedTime]);

  console.log(profileState.timings[0]);
  

  const planState = useSelector(state=>state.plans);


  const [calenderDrop, setcalenderDrop] = useState(false);

  const togglecalenderDropdown = () => {
    setcalenderDrop((prev) => !prev);
  };
  const [shareDrop, setshareDrop] = useState(false);

  const toggleshareDropdown = () => {
    setshareDrop((prev) => !prev);
  };

  const [anchorEl, setAnchorEl] = React.useState(null);
  const [showAccount, setShowAccount] = React.useState(null);
  const open = Boolean(anchorEl);
  const categoryState = useSelector((state) => state.categories);

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };
  const [isPopupOpen, setIsPopupOpen] = useState(false);
  const togglePopup21 = () => {
    setIsPopupOpen((prevState) => !prevState);
    setBusinessId(selector?.details?.business_id);
    // console.log(selector?.details?.business_id);
  };


  const [appointmentDrop, setappointmentDrop] = useState(false);
  const [passwordCurrent, setPasswordCurrent] = useState('');
  const [password, setPassword] = useState('');
  const [passwordConfirm, setPasswordConfirm] = useState('');
  const [showPassword, setShowPassword] = useState(false);
  const [showPassword2, setShowPassword2] = useState(false);
  const [showPassword3, setShowPassword3] = useState(false);
  const toggleappointmentDropdown = () => {
    setappointmentDrop((prev) => !prev);
  };
  const handleLogoUpload = (e) => {
    const file = e.target.files[0];
    if (file) {
      // Create a temporary URL for the selected image
      const previewURL = URL.createObjectURL(file);
      setLogoPreview(previewURL);
      // patchBusinessLogo(selectorAuth?.user?.business_id);
      patchBusinessLogo(dispatch,businessId,file);
    }
  };
  const handleAutoBookToggle = () => {
    const newAutoBookStatus = selector?.details?.auto_book === 0 ? 1 : 0;
    dispatch(setProfileValue({ key: 'auto_book', value: newAutoBookStatus }));
    autoBookOpen(dispatch, newAutoBookStatus, selector.details.business_id);
    console.log(selector.details)
  };

  const onReset = async (passwordCurrent, password,passwordConfirm) => {
    try {
      if (password !== passwordConfirm) {
        // Handle password confirmation mismatch
        return;
      }
  
      // Call the resetPassword function with the necessary arguments
      await changePassword(dispatch, passwordCurrent, password ,selector?.details?.email);
      // console.log(selector?.details?.email);
      // Handle successful password reset (e.g., show a success message)
      // console.log('Password reset successful');
      // console.log(passwordCurrent,password,passwordConfirm);
    } catch (error) {
      // Handle any errors that occur during password reset
      console.log('Password reset error:', error.message);
    }
  };  return (
    <>
    <AppLayout>

      {
        calenderDrop?
        <CalenderPopup closePopup={togglecalenderDropdown} openAppointment={toggleappointmentDropdown}/>
        :<></>
      }
      {appointmentDrop ? (
        // <ServicePopup closePopup={toggleserviceDropdown}/>
        <AppointmentPopup closePopup={toggleappointmentDropdown} />
      ) : (
        <></>
      )}
      {showAccount ? <AccountPopup closePopup={setShowAccount} /> : <></>}
      {shareDrop ? <SharePopup closePopup={toggleshareDropdown} /> : <></>}
      <div className="w-full overflow-scroll h-full flex flex-col items-start gap-4 p-4">
        <Header
          title={"Profile"}
          actions={
            <>
              <IconButton
                onClick={toggleshareDropdown}
              >
                <MdShare size={'1.5rem'}/>
              </IconButton>
              <IconButton onClick={togglecalenderDropdown}>
              <MdCalendarMonth size={'1.5rem'}/>
              </IconButton>
              <IconButton onClick={handleClick}>
                {/* <Avatar sx={{ color: "white", bgcolor: "#0B469D" }}>V</Avatar> */}
                <Avatar sx={{ color: "white", bgcolor: "#0B469D", textTransform:'uppercase' }}>{selectorAuth?.user?.name?.split('')[0]}</Avatar>
              </IconButton>
            </>
          }
        />


        <Menu
          anchorEl={anchorEl}
          id="account-menu"
          open={open}
          onClose={handleClose}
          onClick={handleClose}
          PaperProps={{
            elevation: 0,
            sx: {
              overflow: "visible",
              filter: "drop-shadow(0px 2px 8px rgba(0,0,0,0.32))",
              mt: 1.5,
              "& .MuiAvatar-root": {
                width: 32,
                height: 32,
                ml: -0.5,
                mr: 1,
              },
              "&:before": {
                content: '""',
                display: "block",
                position: "absolute",
                top: 0,
                right: 14,
                width: 10,
                height: 10,
                bgcolor: "background.paper",
                transform: "translateY(-50%) rotate(45deg)",
                zIndex: 0,
              },
            },
          }}
          transformOrigin={{ horizontal: "right", vertical: "top" }}
          anchorOrigin={{ horizontal: "right", vertical: "bottom" }}
        >
          <MenuItem
            onClick={() =>
              nav("/admin/profile/" + selectorAuth?.user?.business_id)
            }
          >
            <Avatar /> Profile
          </MenuItem>
          <Divider />
          <MenuItem onClick={() => {setShowAccount(true)}}>
            <ListItemIcon>
              <MdPeople />
            </ListItemIcon>
            Accounts
          </MenuItem>
          <MenuItem
            onClick={() => {
              deleteAccount(dispatch, selectorAuth?.user?.business_id);
            }}
          >
            <ListItemIcon>
              <MdDelete fontSize="small" />
            </ListItemIcon>
            Delete
          </MenuItem>
          <MenuItem
            onClick={() => {
              logOut(dispatch);
            }}
          >
            <ListItemIcon>
              <MdLogout fontSize="small" />
            </ListItemIcon>
            Logout
          </MenuItem>
        </Menu>

      <div className="w-full flex flex-col p-4 gap-4">
          <div className="w-full flex items-center gap-4">
              <div className="bg-white w-20 h-20 rounded-full flex items-center justify-center text-4xl relative cursor-pointer [&>div]:hover:visible">
                <div className="absolute bg-black/60 top-0 left-0 w-full h-full rounded-full z-10 text-white transition-all invisible flex items-center justify-center text-xl cursor-pointer">
                  <MdEdit onClick={togglePopup21}/>
                </div>
                {selector?.details?.logo ? (
                                      <img
                                        src={selector.details.logo}
                                        alt="Business Logo"
                                        className="w-20 h-20 rounded-full"
                                      />
                                    ) : (
                                      <MdPerson />
                                    )}
              </div>
              {isPopupOpen && (
        <div className="absolute bg-white bg-opacity-80 top-[20%] left-[25%] w-[30%] h-[30%] rounded-full z-10 text-white transition-all flex items-center justify-center">
          <div className="flex flex-col">
          <div className="p-2 bg-white border-blue-700 border-2 rounded-lg">
            
            {logoPreview ? (
                <img src={logoPreview} alt="Logo Preview" className="w-32 h-32 mb-2" />
              ) : (
                <label htmlFor="logoUpload" className="text-black text-l mb-2 cursor-pointer">
                  Upload Your Logo
                </label>
              )}
              <input
                type="file"
                id="logoUpload"
                className="hidden"
                onChange={handleLogoUpload}
              />
            </div>
            <button
              onClick={() => {
                setLogoPreview(null);
                togglePopup21();
              }}
              className="mt-4 px-4 py-2 border-b-2 border-blue-400 text-black rounded-md cursor-pointer"
            >
              Close X
            </button>            
            </div>
        </div>
      )}

              <div>
              <h2 className="font-bold text-xl text-black capitalize">{selector?.details?.name}</h2>
              <p className="flex items-center gap-2"> <MdEmail/><span>{selector?.details?.email}</span></p>
            </div>
            <div className="border border-primary rounded p-2 ml-auto flex items-center gap-2 text-primary">
              <MdCurrencyRupee/>
              {selector?.details?.credit?.toFixed(2)}
            </div>
          </div>
          <Grid container spacing={4}>
            <Grid item xs={16} lg={6}>
          <AppointmentAccordian title={'General'}>
           <Grid container spacing={4} py={2}>
            <Grid item xs={6}>
            <InputComponents
              placeholder="Name"
              value={selector.details?.name}
              onChange={(ev)=>{
                dispatch(setProfileValue({key:'name',value:ev.target.value}));
              }}
            />
            </Grid>
            <Grid item xs={6}>
            <InputComponents
              value={selector.details?.contact}
              placeholder="Contact"
              onChange={(ev)=>{
                dispatch(setProfileValue({key:'contact',value:ev.target.value}));}}
            />
            </Grid>
            <Grid item xs={16}>
            <InputComponents
              value={selector.details?.address}
              placeholder="Address"
              onChange={(ev)=>{
                dispatch(setProfileValue({key:'address',value:ev.target.value}));
              }}
            />
            </Grid>
            <Grid item xs={6}>
            <InputComponents
              value={selector.details?.owner}
              placeholder="Owner"
              onChange={(ev)=>{
                dispatch(setProfileValue({key:'owner',value:ev.target.value}));}}
            />
            </Grid>
            <Grid item xs={6}>
            <select className="!bg-transparent" value={selector.details?.business_type} onClick={()=>{}} onChange={(ev)=>{
                dispatch(setProfileValue({key:'business_type',value:Number(ev.target.value)}));}}>
                  <option value={0} disabled>Industry Type</option>
                  {
                    categoryState.data?.map((el,inD)=>
                    <option value={el.preset_id} disabled={false} key={inD}>{el.business_type}</option>
                    )
                  }
                </select>
            {/* <InputComponents
              value={selector.details?.type}
              placeholder="Business Type"
              onChange={(ev)=>{}}
            /> */}
            </Grid>
            <Grid xs={16} item>
           <button 
           onClick={()=>{
            // console.log(selector.details);
            const req = {
              address: selector.details.address,
              contact: selector.details.contact,
              owner: selector.details.owner,
              name: selector.details.name,
              type: selector.details.business_type,
            }
            updateProfile(dispatch,req,selector.details);
           }}
           className="button w-full">SAVE</button>
            </Grid>
           </Grid>
          </AppointmentAccordian>
          <AppointmentAccordian title={'Change Password'} defaultExpanded={false} >
            <div className="w-full flex flex-col gap-4 py-2">
            <div className="flex gap-4 flex-col">
              <div className="flex">
            <input
                type={showPassword ? 'text' : 'password'}
                placeholder="Enter current password"
                onChange={(e) => setPasswordCurrent(e.target.value)}
              />
              <span className=" mt-3 ml-2 cursor-pointer" onClick={() => setShowPassword(!showPassword)}>
                {showPassword ? <FaEye /> : <FaEyeSlash />}
              </span>
              </div>
              <div className="flex">
            <input
                type={showPassword2 ? 'text' : 'password'}
                placeholder="Enter new password"
                onChange={(e) => setPassword(e.target.value)}
                />
              <span className=" mt-3 ml-2 cursor-pointer" onClick={() => setShowPassword2(!showPassword2)}>
              {showPassword2 ? <FaEye /> : <FaEyeSlash/>}
            </span>
              </div>
              <div className="flex">
            <input
                  type={showPassword3 ? 'text' : 'password'}
                  placeholder="Enter Confirm password"
                  onChange={(e) => setPasswordConfirm(e.target.value)}
                />
                <span className=" mt-3 ml-2 cursor-pointer" onClick={() => setShowPassword3(!showPassword3)}>
                  {showPassword3 ? <FaEye /> : <FaEyeSlash />}
                </span>
              </div>
            </div>
                <button className="button" onClick={() => onReset(passwordCurrent, password, passwordConfirm)}>RESET</button>
            </div>
          </AppointmentAccordian>
            </Grid>
            <Grid item xs={16} lg={6}>
          
          <Dialog open={confirmTimings}>
            <DialogTitle>Are you sure you want to change the business hours?</DialogTitle>
            <DialogContent>If yes, please update the slots as weekly or no-recurring</DialogContent>
            <DialogActions>
              <Button onClick={()=>{setconfirmTimings(false)}}>CANCEL</Button>
              {/* <Button variant="contained"> */}
                <button className="button !px-10" onClick={async()=>{
          
const req = {
  'start_time':(profileState.timings[0].startTime.hour() < 10 ? `0${profileState.timings[0].startTime.hour()}` : profileState.timings[0].startTime.hour()) +
  ":" +
  (profileState.timings[0].startTime.minute() < 10 ? `0${profileState.timings[0].startTime.minute()}` : profileState.timings[0].startTime.minute()) +
  ":00",
'end_time':(profileState.timings[0].endTime.hour() < 10 ? `0${profileState.timings[0].endTime.hour()}` : profileState.timings[0].endTime.hour()) +
":" +
(profileState.timings[0].endTime.minute() < 10 ? `0${profileState.timings[0].endTime.minute()}` : profileState.timings[0].endTime.minute()) +
":00",
'off':profileState.timings[0].off,
'day':profileState.selectedTime,
}
await savetimings(dispatch,req);
setconfirmTimings(false);
                }}>
                Proceed
                </button>
                {/* </Button> */}
            </DialogActions>
          </Dialog>

          <AppointmentAccordian title={'Timings'}>
            <div className="w-full flex flex-col gap-4 py-2">
              {/* <div className=" flex justify-between"> */}
            <FormControlLabel
                  
                  value={1}
                  control={
                    <Switch
                    //   checked={generalState.generalParameters.type_of_unit.includes(
                    //     "manufacturing"
                    //   )
                    // }
                    checked={selector?.details?.off===1}
                      onChange={(ec, checked) => {
                        dispatch(setProfileValue({key:'off',value:selector?.details?.off===0?1:0}));
                        updateProfileOpen(dispatch,selector?.details?.off===0?1:0,selector.details);
                        // dispatch(setTypesOfUnit("manufacturing"));
                      }}
                    />
                  }
                  label="Temporary Off"
                />
                {/* <FormControlLabel
                    value={1}
                    control={
                      <Switch
                        checked={selector?.details?.auto_book === 0}
                        onChange={handleAutoBookToggle}
                      />
                    }
                    label="Auto Book Off"
                  />
                  </div> */}
            {/* <FormControlLabel
                  
                  value={1}
                  control={
                    <Switch
                    //   checked={generalState.generalParameters.type_of_unit.includes(
                      //     "manufacturing"
                    //   )
                    // }
                    checked={selector?.details?.off===1}
                      // onChange={(ec, checked) => {
                      //   dispatch(setProfileValue({key:'off',value:selector?.details?.off===0?1:0}));
                      //   updateProfileOpen(dispatch,selector?.details?.off===0?1:0,selector.details);
                      //   // dispatch(setTypesOfUnit("manufacturing"));
                      // }}
                      />
                    }
                    label="Temporary Off"
                    />
                </div> */}
            <div className="flex bg-white text-xs rounded-sm border-primary border items-center">
              {
                [1,2,3,4,5,6,7].map((el,i)=>{
                  return <div onClick={()=>dispatch(setselectedTime(dayOfWeek[i]))} className={`cursor-pointer border ${profileState.selectedTime === dayOfWeek[i]?'bg-primary text-white':'text-primary'} transition-all border-primary text-primary flex-1 h-fit p-2 flex items-center justify-center`}>
                    {
                      dayOfWeek[i]
                    }
                  </div>
                })
              }
            </div>
            <div className="flex gap-4">
              <TimeField label='Start Time' size="small" 
              onChange={(newValue)=>
                dispatch(setTimingsValue({
                  key:'startTime',
                  value: newValue
                }))
              }
              value={Array.isArray(profileState.timings) && profileState.timings?.length > 0?profileState.timings[0]?.startTime:dayjs(new Date().toISOString())}/>
              <TimeField label='End Time' size="small" 
              onChange={(newValue)=>
                dispatch(setTimingsValue({
                  key:'endTime',
                  value: newValue
                }))
              }
              value={Array.isArray(profileState.timings) && profileState.timings?.length > 0?profileState.timings[0]?.endTime:dayjs(new Date().toISOString())}/>
              {/* <TimeField label='End Time' size="small"/> */}
                  <FormControlLabel
                  
                    value={1}
                    control={
                      <Switch
                      //   checked={generalState.generalParameters.type_of_unit.includes(
                      //     "manufacturing"
                      //   )
                      // }
                      checked={Array.isArray(profileState.timings) && profileState.timings?.length > 0?profileState.timings[0].off === 0:false}
                        onChange={(ec, checked) => {
                          dispatch(setTimingsValue({
                            key:'off',
                            value: Array.isArray(profileState.timings) && profileState.timings?.length > 0?profileState.timings[0].off === 0?1:0:0
                          }))
                          // dispatch(setTypesOfUnit("manufacturing"));
                        }}
                      />
                    }
                    label="Open"
                  />

            </div>
                  <button className="button" onClick={()=>{
                    setconfirmTimings(true);
                  }}>SAVE</button>
            </div>
          </AppointmentAccordian>
          <AppointmentAccordian title={'Social Media'} defaultExpanded={false}>
          <div className="w-full flex flex-col gap-4 py-2">
            <div className="flex flex-col gap-4">
              <div className="w-full flex items-center gap-2">
                  <InputComponents
                  value={selector.details?.facebook}
                  onChange={(ev)=>{
                    dispatch(setProfileValue({key:'facebook',value:ev.target.value}));
                  }}
                  placeholder="Facebook url"
                  />
                  <IconButton>
                    <MdSave
                    onClick={()=>{
                      updateLabelProfile(dispatch,'facebook',selector.details?.facebook,selector.details);
                    }}
                    />
                  </IconButton>
              </div>
              <div className="w-full flex items-center gap-2">
                  <InputComponents
                  value={selector.details?.instagram}
                  onChange={(ev)=>{
                    dispatch(setProfileValue({key:'instagram',value:ev.target.value}));
                  }}
                  placeholder="Instagram url"
                  />
                  <IconButton>
                    <MdSave onClick={()=>{
updateLabelProfile(dispatch,'instagram',selector.details?.instagram,selector.details);
                    }}/>
                  </IconButton>
              </div>
              <div className="w-full flex items-center gap-2">
                  <InputComponents
                  value={selector.details?.linkedin}
                  onChange={(ev)=>{
                    dispatch(setProfileValue({key:'linkedin',value:ev.target.value}));
                  }}
                  placeholder="LinkedIn url"
                  />
                  <IconButton>
                    <MdSave onClick={()=>{
updateLabelProfile(dispatch,'linkedin',selector.details?.linkedin,selector.details);
                    }}/>
                  </IconButton>
              </div>
              <div className="w-full flex items-center gap-2">
                  <InputComponents
                  value={selector.details?.twitter}
                  onChange={(ev)=>{
                    dispatch(setProfileValue({key:'twitter',value:ev.target.value}));
                  }}
                  placeholder="Twitter url"
                  />
                  <IconButton>
                    <MdSave onClick={()=>{
updateLabelProfile(dispatch,'twitter',selector.details?.twitter,selector.details);
                    }}/>
                  </IconButton>
              </div>
              <div className="w-full flex items-center gap-2">
                  <InputComponents
                  value={selector.details?.website}
                  onChange={(ev)=>{

                    dispatch(setProfileValue({key:'website',value:ev.target.value}));
                  }}
                  placeholder="Website url"
                  />
                  <IconButton>
                    <MdSave onClick={()=>{

updateLabelProfile(dispatch,'website',selector.details?.website,selector.details);
                    }}/>
                  </IconButton>
              </div>
              {/* <FormikForm
              initialValues={initialValuesSocailMedia}
              fields={feildsSocailMedia}
              validationSchema={{}}
              action={()=><button className="button">SAVE</button>}
              /> */}
            </div>
            </div>
          </AppointmentAccordian>
            </Grid>
            <Grid item xs={16} lg={6}>
                    <AppointmentAccordian title={'Remaining'}>
                      <Grid container spacing={2} justifyContent={'space-evenly'}>
                      <Grid item xs={4}>
                        <div className="w-full flex flex-col items-center">
                        <h4 className="text-primary">SMS</h4>
                        <h2 className="text-primary font-bold text-2xl">{selector?.details?.sms_limit}</h2>
                        </div>
                      </Grid>
                      <Grid item xs={4}>
                        <div className="w-full flex flex-col items-center">
                        <h4 className="text-primary">Months</h4>
                        <h2 className="text-primary font-bold text-2xl capitalize">{moment(selector?.details?.expired_plan).diff(moment(),'months')}</h2>
                        </div>
                      </Grid>
                      <Grid item xs={4}>
                        <div className="w-full flex flex-col items-center">
                        <h4 className="text-primary">Storage</h4>
                        <h2 className="text-primary font-bold text-2xl">{((selector?.details?.storage_limit||0)/1024).toFixed(2)>=1?((selector?.details?.storage_limit||0)/1024).toFixed(2):((selector?.details?.storage_limit||0)).toFixed(2)} {((selector?.details?.storage_limit||0)/1024).toFixed(2)>0?'GB':'MB'}</h2>
                        </div>
                      </Grid>
                      <Grid item xs={4}>
                        <div className="w-full flex flex-col items-center">
                        <h4 className="text-primary">Staff</h4>
                        <h2 className="text-primary font-bold text-2xl">{selector?.details?.staff_limit}</h2>
                        </div>
                      </Grid>
                      <Grid item xs={4}>
                        <div className="w-full flex flex-col items-center">
                        <h4 className="text-primary">Patients</h4>
                        <h2 className="text-primary font-bold text-2xl">{(selector?.details?.customer_limit || 0) <= 999999?(selector?.details?.customer_limit || 0):'Unlimited'}</h2>
                        </div>
                      </Grid>
                      <Grid item xs={4}>
                        <div className="w-full flex flex-col items-center">
                        <h4 className="text-primary">Current Plan</h4>
                        <h2 className="text-primary font-bold text-2xl uppercase">{planState.plans?.find(ev=>ev.id === selector?.details?.subscription)?.name}</h2>
                        <Link to="/admin/pricePlan" className="text-sm text-blue-600 mt-1">Upgrade plan</Link>
                        </div>
                      </Grid>
                      </Grid>
                    </AppointmentAccordian>
            </Grid>
            <Grid item xs={16} lg={6}>
                    <AppointmentAccordian title={'Recent payments'}>
                      <List className="">
                          <ListItem>
                            <ListItemText></ListItemText>
                            <ListItemIcon>
                              <Link to={'/admin/subscription/billing'}>
                              See more
                              </Link>
                            </ListItemIcon>
                          </ListItem>
                          {
                            planState?.billings?.slice(0,2)?.map((el,i)=>
                            <ListItem key={i}>
                                <ListItemText><span className="font-bold text-lg">{planState.plans?.find(ev=>ev.id === el?.plan)?.name}</span> <span>({el.month_count})</span></ListItemText>
                                <ListItemIcon sx={{display:'flex',alignItems:'center'}}><MdCurrencyRupee/> <span>{el.month_price}</span></ListItemIcon>
                            </ListItem>
                            )
                          }
                      </List>
                    </AppointmentAccordian>
            </Grid>
            <Grid item xs={16}>
              <GoogleCalendarSettings />
            </Grid>
          </Grid>
      </div>
      </div>
    </AppLayout>
    </>
  );
};

export default Profile;
